<template>
  <router-view></router-view>
</template>

<script>
import { loadUserback, destroyUserback } from '@/plugins/userback';

export default {
  name: 'App',
  computed: {
    authReady() {
      const a = this.$auth;
      return !!(a
        && !a.loading
        && a.isAuthenticated
        && a.user
        && a.user.UserDetails
        && a.user.UserDetails.Contact_RecID);
    },
    shouldShowUserback() {
      return this.authReady && this.$route.path !== '/site-inactive';
    }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler(path) {
        document.body.classList.toggle(
          'site-inactive-page',
          path === '/site-inactive'
        );
      }
    },
    shouldShowUserback: {
      immediate: true,
      handler(show) {
        if (show) {
          loadUserback(this.$auth.user);
        } else {
          destroyUserback();
        }
      }
    }
  },
  beforeDestroy() {
    destroyUserback();
  }
};
</script>

<style lang="scss">
  @import 'assets/scss/style';

  body.site-inactive-page {
    #userback_button_container,
    iframe[src*="userback"] {
      display: none !important;
    }
  }
</style>